import {
  PhoneIcon,
  PhoneXMarkIcon,
  MicrophoneIcon,
  PauseIcon,
} from '@heroicons/react/24/solid';

interface CallControlsProps {
  callState: 'idle' | 'ringing_out' | 'ringing_in' | 'in_call' | 'on_hold';
  isMuted: boolean;
  onCall: () => void;
  onHangup: () => void;
  onAnswer: () => void;
  onToggleMute: () => void;
  onToggleHold: () => void;
}

export function CallControls({
  callState,
  isMuted,
  onCall,
  onHangup,
  onAnswer,
  onToggleMute,
  onToggleHold,
}: CallControlsProps) {
  if (callState === 'idle') {
    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={onCall}
          className="flex items-center justify-center w-14 h-14 rounded-full
                     bg-emerald-500 hover:bg-emerald-600 text-white
                     transition-colors shadow-lg shadow-emerald-500/25"
        >
          <PhoneIcon className="w-6 h-6" />
        </button>
      </div>
    );
  }

  if (callState === 'ringing_in') {
    return (
      <div className="flex justify-center gap-6">
        <button
          type="button"
          onClick={onHangup}
          className="flex items-center justify-center w-14 h-14 rounded-full
                     bg-red-500 hover:bg-red-600 text-white
                     transition-colors shadow-lg shadow-red-500/25"
        >
          <PhoneXMarkIcon className="w-6 h-6" />
        </button>
        <button
          type="button"
          onClick={onAnswer}
          className="flex items-center justify-center w-14 h-14 rounded-full
                     bg-emerald-500 hover:bg-emerald-600 text-white
                     transition-colors shadow-lg shadow-emerald-500/25 animate-pulse"
        >
          <PhoneIcon className="w-6 h-6" />
        </button>
      </div>
    );
  }

  // ringing_out, in_call, on_hold
  return (
    <div className="flex justify-center gap-4">
      <button
        type="button"
        onClick={onToggleMute}
        className={`flex items-center justify-center w-12 h-12 rounded-full
                    transition-colors ${
                      isMuted
                        ? 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400'
                        : 'bg-zinc-100 text-zinc-600 hover:bg-zinc-200 dark:bg-zinc-800 dark:text-zinc-400'
                    }`}
        title={isMuted ? 'Zapnout mikrofon' : 'Ztlumit mikrofon'}
      >
        <MicrophoneIcon className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={onToggleHold}
        className="flex items-center justify-center w-12 h-12 rounded-full
                   bg-zinc-100 text-zinc-600 hover:bg-zinc-200
                   dark:bg-zinc-800 dark:text-zinc-400 transition-colors"
        title="Podržet"
      >
        <PauseIcon className="w-5 h-5" />
      </button>

      <button
        type="button"
        onClick={onHangup}
        className="flex items-center justify-center w-14 h-14 rounded-full
                   bg-red-500 hover:bg-red-600 text-white
                   transition-colors shadow-lg shadow-red-500/25"
      >
        <PhoneXMarkIcon className="w-6 h-6" />
      </button>
    </div>
  );
}
